import { searchBox } from "instantsearch.js/es/widgets";

const searchBoxWidget = (I18n) =>
  searchBox({
    container: "#search-box",
    placeholder: I18n.translate(
      "stimulus.professional_search.search_box_placeholder",
    ),
    showReset: false,
    showSubmit: false,
    showLoadingIndicator: false,
    searchAsYouType: true,
    cssClasses: {
      input: "form-control w-100 form-control-lg",
    },
  });

export default searchBoxWidget;
